import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EmptyData } from "../../../../components/empty/emptyData";
import { EntAgroculturalCooperative } from "../../../../models/mechanization/agroculturalCooperative";
import { AddAgroculturalCooperativeModal } from "./AddAgroculturalCooperativeModal";
import { EntAgroculturalCooperativeFilter } from "../../../../models/filters/agroculturalCooperativeFilter";
import { useAgroculturalCooperative } from "./useAgriculturalCooperative";
import { FilterAgroculturalCooperative } from "./FilterAgroculturalCooperative";
import { useLazyGetAgroculturalCooperativeListFilteredQuery } from "../../../../redux/api/mechanization/agroculturalCooperativeApi";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import ReportDepartmentMechModal from "../reportDepartmentMech/ReportDepartmentMechModal";
import { useGetReportByCooperativesMutation } from "../../../../redux/api/mechanization/reportDepartmentMechApi";

enum FormField {
  name,
}

export const AgroculturalCooperative = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntAgroculturalCooperative>(new EntAgroculturalCooperative());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [ showReportModal, setShowReportModal ] = useState<boolean>(false);
  const {t}= useTranslation();
  const [form] = useForm();
    const [getCooperativeReport] = useGetReportByCooperativesMutation();
    const [getArchiveFolders] = useLazyGetAgroculturalCooperativeListFilteredQuery();

  const {
    filter,
    fetching,
    data,
    access,
    totalItems,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntAgroculturalCooperative, EntAgroculturalCooperativeFilter>({
    initialFilter: new EntAgroculturalCooperativeFilter(),
    query: getArchiveFolders
  });
  const { onAddAgroculturalCooperative, onEditAgroculturalCooperative, onDeleteAgroculturalCooperative } = useAgroculturalCooperative(modal, () => { searchHandleClick(); });
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isMechAvailable = storedData.some((route: any) => (route.alias === "/departments/mechanization/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntAgroculturalCooperative) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const setEntityFromFields = (): EntAgroculturalCooperativeFilter => {
    let filt: EntAgroculturalCooperativeFilter = _.clone(filter);
    filt.name = form.getFieldValue(FormField.name) ?? null;
    filt.page = 1;
    return filt;
  };

  const clearFields = () => {
    form.setFields([
      { name: FormField.name, value: null },
    ]);
  };

  const searchHandleClick = () => {
    setFilter(setEntityFromFields());
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  };

  const getReport = async (payload: {languageEnum: string }): Promise<Blob> => {
    return await getCooperativeReport(payload).unwrap();
  };

  const table = (
    <div style={{ maxHeight: `${height}px`, overflow: 'auto' }} onScroll={scrollHandler}>
      <table>
        <thead>
          <tr>
            <th style={{ width: "40px" }}>#</th>
            <th>{ t('general.year') }</th>
            <th>{ t('mechanisation.agricultural_cooperative.legalAddressTerritorialUnit') }</th>
            <th>{t('general.name')}</th>
            <th>{ t('mechanisation.agricultural_cooperative.supervisor_full_name') }</th>
            <th>{ t('mechanisation.agricultural_cooperative.phone_num') }</th>
            <th style={{ width: "120px" }}></th>
          </tr>
        </thead>
        <tbody>
          {fetching ?
            <tr>
              <th colSpan={6}>
                <Spin spinning={fetching} style={{
                  width: '100%',
                  height: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }} />
              </th>
            </tr>
            : <></>}
          {data.length !== 0 ? data.map((item, index) => (
                  <tr key={ item.id }>
                    <td>{ ++index }</td>
                    <td>{ item.year }</td>
                    <td>{ i18n.language === 'ru' ? item.legalAddressTerritorialUnit?.nameRu : item.legalAddressTerritorialUnit?.nameKy }</td>
                    <td>{ item.name } </td>
                    <td>{ item.managerFullName } </td>
                    <td>{ item.phoneNumber } </td>
                    <td>
                      <Flex gap="small">
                        { access && access.methodPut && (
                        <Tooltip title={ t('general.edit') }>
                          <Button className='btn_edit' onClick={ () => {
                            openAddModal(item)
                          } } type="primary" shape="circle" icon={ <EditOutlined/> }/>
                        </Tooltip>
                          )}
                        { access && access.methodDelete && (
                        <Tooltip title={ t('general.delete') }>
                          <Button className='btn_edit' danger onClick={ () => {
                            onDeleteAgroculturalCooperative(item)
                          } } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
                        </Tooltip>
                          )}
                      </Flex>
                    </td>
                  </tr>
              )) :
              <tr>
                <td colSpan={ 6 }>
                  <EmptyData/>
                </td>
              </tr>}
        </tbody>
      </table>
    </div>
  );

  return (
    <>
      <PageHeader
        title={ t('titles.agricultural_cooperative') }
        additionalInfo={
          <Typography.Text style={{ marginBottom: '0.5em', display: 'block' }} type="secondary">
            { t('mechanisation.agricultural_cooperative.agricultural_cooperative_desc') } {t('general.records_found')} {totalItems}
          </Typography.Text>
        }
      />
      { access && access.methodPost && (
      <Button type="primary" icon={<PlusOutlined />} onClick={() => { openAddModal(new EntAgroculturalCooperative()) }}>
        { t('general.add') }
      </Button>
        )}
      { isMechAvailable && (
      <Button style={{marginLeft: '5px'}} type="primary" icon={ <PlusOutlined/> } onClick={ () => setShowReportModal(true) }>
        { t('general.generate_report') }
      </Button>
        )}
      <ContentPartFilter
        filter={<FilterAgroculturalCooperative onSearch={searchHandleClick} onReset={() => { clearFields(); searchHandleClick() }} formField={FormField} form={form} />}
        setHeight={setHeight}
        table={table}
      />
      <AddAgroculturalCooperativeModal
        agroculturalCooperative={selectedItem}
        show={showModal}
        onHide={() => {
          setShowModal(false)
          setSelectedItem(new EntAgroculturalCooperative())
        }}
        onSubmit={selectedItem.id !== null ? onEditAgroculturalCooperative : onAddAgroculturalCooperative}
      />
      <ReportDepartmentMechModal
        type={ 'cooperatives' }
        title={ t('reports.report_by_cooperatives') }
        getReport={ getReport }

        show={ showReportModal }
        onHide={ () => setShowReportModal(false) }
      />
      {contextHolder}
    </>
  );
};
